import React from "react";
import AdminCustomersList from "components/customers/admin/AdminCustomersList";

export default function PageAdminOrdersList() {
  return (

    <div id="page-admin-orders-list"
      class="py-4 container-fluid pe-2">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="h4 m-0">
          <span>Clients</span>
        </h1>
      </div>
      <div className="container">
        <AdminCustomersList />
      </div>
    </div>
  );
}